import { useLayoutEffect, useState, useEffect, useCallback } from "react";
import { Button, SelectBox } from "devextreme-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import TextArea from "devextreme-react/text-area";
import {
  askConfirmation,
  showErrorMessage,
  showResponseMessage,
  showSuccessMessage,
  showWarningMessage,
} from "../../../helper/message.js";
import { assetService } from "../../../apis/apiServices/Asset";
import { AssetSubStatus } from "../../../helper/fixcode";
import DataGrid from "devextreme-react/data-grid";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi.js";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { Loader } from "../../Shared/PageLoader";

export default function ViewAssetHireQuotationComponent(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.data);
  const [state, setState] = useState({
    isAssetPurchaseApprove: false,
    isAssetPurchaseBacktoDraft: false,
    isAssetPurchaseRecall: false,
    remark: "",
    assetQuotationId: location?.state?.requestQuotationId ?? 0,
    quotationTypeId: location?.state?.quotationTypeId ?? 0,
    quotationIndentNo: location?.state?.quotationIndentNo ?? 0,
    isAddRemarkModalOpen: false,
    actionTypeId: 0,
    isCompleteLoading: false,
    loadingMessage: "",
  });
  const [errors, setErrors] = useState({
    remarkValidation: "",
  });
  const [purchaseContent, setContent] = useState("");
  const { sourceUrl } = location.state || {};
  const [assetQuotationSubDataSourceLst, setAssetQuotationSubDataSourceLst] = useState([]);
  const [assetQuotationVendorLst, setAssetQuotationVendorLst] = useState([]);
  const [assetQuotationVendorAttachment, setAssetQuotationVendorAttachment] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [quotationAllVendorLineItemLst, setQuotationAllVendorLineItemLst] = useState([]);
  const [assetData, setAssetData] = useState(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Asset Hire Preview";
  }, []);
  
  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));

      await Promise.all([
        getAssetQuotation(state.assetQuotationId),
        getAssetQuotationSub(state.assetQuotationId),
        getQuotationAllVendorLineItems(),
        getAssetQuotationVendor(state.assetQuotationId),
        getAssetQuotationVendorAttachments(state.assetQuotationId),
      ]);

      // await getAssetQuotation(state.assetQuotationId);
      // await getAssetQuotationSub(state.assetQuotationId);
      // await getQuotationAllVendorLineItems();
      // await getAssetQuotationVendor(state.assetQuotationId);
      // await getAssetQuotationVendorAttachments(state.assetQuotationId);
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetQuotation = async () => {
    try {
      let body = {
        quotationRequestId: state.assetQuotationId,
        statusId: 0,
        userId: user.userId,
        quotationTypeId: 2,
      };
      const response = await assetService.assetQuotationById(body);      
      setAssetData(response?.data);
      setContent(response?.data?.quoteContent ?? "");

      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));

      // setTimeout(async () => {
      //     await getWorkflowCategory(response?.data[0]?.fromProjectId ?? 0);
      // }, 0);

      // setState((prev) => ({
      //     ...prev,
      //     userId: response?.data[0]?.toId ?? 0,
      //     fromId: response?.data[0]?.fromId ?? 0,
      //     toId: state.toId > 0 ? state.toId : response?.data[0]?.toId,
      //     fromProjectId: state.fromProjectId > 0 ? state.fromProjectId : response?.data[0]?.fromProjectId,
      //     fromProjectName: response?.data[0]?.fromProjectName ?? "",
      //     fromLocationName: response?.data[0]?.fromLocation ?? "",
      //     fromDepartmentId: response?.data[0]?.fromDepartmentId ?? 0,
      //     fromDepartment: response?.data[0]?.fromDepartment ?? "",
      //     toProjectId: response?.data[0]?.toProjectId ?? 0,
      //     toProjectName: response?.data[0]?.toProjectName ?? "",
      //     toLocationName: response?.data[0]?.toLocation ?? "",
      //     toDepartmentId: response?.data[0]?.toDepartmentId ?? 0,
      //     toDepartment: response?.data[0]?.toDepartment ?? "",
      //     note: response?.data[0]?.note ?? "",
      //     isValid: response?.data[0]?.isValid ?? false,
      //     workflowCategoryId: response?.data[0]?.categoryId ?? 0,
      //     workflowId: response?.data[0]?.workflowId ?? 0,
      //     workflowDepartmentId: response?.data[0]?.fromDepartmentId ?? 0,
      // }));
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  };

  const getAssetQuotationSub = async () => {
    try {
      let body = {
        quotationRequestId: state.assetQuotationId,
        statusId: 0,
        quotationTypeId: 2,
      };
      const response = await assetService.assetQuotationById(body);
      //console.log(response?.data?.assetQuotationSub[0]);
      setAssetQuotationSubDataSourceLst(
        response?.data?.assetQuotationSub[0] ?? []
      );
      setSelectedRowKeys(response?.data?.assetQuotationSub[0]?.requestSubId);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const getAssetQuotationVendor = async (assetQuotationId) => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await assetService.getAssetQuotationVendors(
        assetQuotationId,
        0
      );
      setAssetQuotationVendorLst(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const getAssetQuotationVendorAttachments = async (assetQuotationId) => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await assetService.getAssetQuotationVendorAttachments(
        assetQuotationId,
        0
      );
      //console.log(response?.data);
      setAssetQuotationVendorAttachment(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const getQuotationAllVendorLineItems = async () => {
    try {
      var request = {};
      request.quotationRequestId = state.assetQuotationId;
      request.vendorId = 0;
      const response = await assetService.getQuotationAllVendorLineItems(
        request
      );
      //console.log(response?.data);
      setQuotationAllVendorLineItemLst(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const GetWorkFlowForApprovers = async (
    formId,
    formCategoryId,
    projectId,
    departmentId
  ) => {
    try {
      let body = {
        formId: formId,
        categoryId: formCategoryId || 0,
        projectId: projectId || 0,
        departmentId: departmentId || 0,
        companyId: user?.companyId || 0,
      };
      // if (
      //   body.formId > 0 &&
      //   body.categoryId > 0 &&
      //   body.projectId > 0 &&
      //   body.departmentId > 0
      // )
      {
        const response = await vishwamApi.getWorkFlowForApprovalForAsset(body);
        return response;
        //console.log(JSON.stringify(response));
        //setWorkflowData(response);
        // const stagesWithApprovers = response?.stages
        //   ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        //   ?.map((stage) => ({
        //     actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
        //     approvers: stage?.approvers,
        //   }));
        // const Approvers = response?.stages
        //   ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        //   ?.flatMap((stage) =>
        //     stage?.approvers?.map((approver) => ({
        //       actionTypeId: stage?.actionTypeId,
        //       userId: approver?.userId,
        //       canEdit: approver?.canEdit,
        //       stageId: stage?.index,
        //     }))
        //   );
        // setAssetRequestApprovers(Approvers);
        // setAssetRequestApproversByWorkflow(stagesWithApprovers);
      }
      // console.log(Approvers);
    } catch (error) {
      console.log("Error getWorkFlowForApprovers===>", error);
    }
  };

  const isValidRemarkData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.remarkValidation = "";
      if (!state.remark) {
        isValid = false;
        err.remarkValidation = "Please enter remark.";
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnUpdateAssetRequest = async (e) => {
    e.preventDefault();
    try {
      let workflowCategoryId = 0;

      let categorybody = {
        formId: props.featurePermission.featureId,
        projectId: assetData.toProjectId,
        departmentId: assetData.departmentId,
      };
      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );
      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }

      let workflowData = await GetWorkFlowForApprovers(
        props.featurePermission.featureId,
        workflowCategoryId,
        assetData.toProjectId,
        assetData.departmentId
      );
      //console.log(JSON.stringify(workflowData));

      if (workflowData === null) {
        await showErrorMessage(`Workflow not set for this category!!`);
        return;
      }

      const Approvers = workflowData?.stages
        ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        ?.flatMap((stage) =>
          stage?.approvers?.map((approver) => ({
            actionTypeId: stage?.actionTypeId,
            userId: approver?.userId,
            canEdit: approver?.canEdit,
            stageId: stage?.index,
          }))
        );
      //console.log(JSON.stringify(Approvers));
      const lastStageData = Approvers.sort((a, b) => b.stageId - a.stageId);
      // Find the highest stageId
      const maxStageId = Math.max(...Approvers.map((item) => item.stageId));
      // Filter only those with the highest stageId
      const highestStageItems = Approvers.filter(
        (item) => item.stageId === maxStageId
      );
      var matchedStage = highestStageItems.filter(
        (e) => e.userId === user?.userId
      );

      setState((prev) => ({ ...prev, isAssetPurchaseApprove: true }));
      let confirmationQuestion = `Are you sure you want to approve this asset hire request?`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );

      if (!isConfirmed) {
        setState((prev) => ({ ...prev, isAssetPurchaseApprove: false }));
        return;
      }
      
      let body = {
        AssetQuotationPurchaseRequestId: state.assetQuotationId,
        statusId: AssetSubStatus.RequestForAssetServiceOrderApproved,
        // statusId:
        //   state.quotationTypeId === 1
        //     ? AssetSubStatus.RequestForAssetPurchaseApproved
        //     : AssetSubStatus.RequestForAssetServiceOrderApproved,
        Remark: state.remark,
        userId: user?.userId,
        assetId: [],
        isSentForApproval: false,
      };

      const response = await assetService.updateAssetQuotationPurchaseRequestStatus(body);

      if (matchedStage.length === 0) {
        if (response?.isSuccess && response.statusCode === 200) {
          //For showing warning message....in case of it is send back to draft
          await showSuccessMessage(response?.message);
          setState((prev) => ({
            ...prev,
            isAssetPurchaseApprove: false,
            isAddRemarkModalOpen: false,
          }));

          if (user?.isIframe) {
            window.parent.postMessage(
              { type: "CLOSE_IFRAME" },
              process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
            );
            return;
          } else {
            if (location.state.sourceUrl === "MyTasks") {
              navigate("/MyTasks");
            } else {
              navigate("/RequestAssetHire");
            }
          }
          return;
        }
      }

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setState((prev) => ({ ...prev, isAssetPurchaseApprove: false }));
        return;
      }

      if (matchedStage.length > 0) {
        if (response?.isSuccess) {
          let assetId = [];
          assetId.push(selectedRowKeys);

          let workflowCategory = {};
          workflowCategory.formId = props.featurePermission?.featureId;
          workflowCategory.categoryId = workflowCategoryId;
          workflowCategory.projectId = assetData?.toProjectId;
          workflowCategory.departmentId = assetData?.departmentId;

          let assetbody = {
            assetRequestId: state.assetQuotationId,
            statusId: AssetSubStatus.SendforPR,
            remark: "",
            userId: user?.userId,
            assetId: assetId,
            departmentId: workflowData.departmentId,
            workFlowId: workflowData.id,
            formName: props?.featurePermission?.featureName || "",
            formId: props.featurePermission?.featureId,
            isLoginUserRequester:
              Approvers?.[0]?.actionTypeId === 8 ? false : true,
            WorkflowCategoryRequest: workflowCategory,
            quotationTypeId: 2,
          };

          const assetresponse = await assetService.moveAssetRequestToPurchase(
            assetbody
          );

          Swal.fire("Success!", `${response?.message}`, "success").then(() => {
            if (location.state.sourceUrl === "MyTasks") {
            navigate("/MyTasks");
          } else {
            navigate("/RequestAssetHire");
          }

            //window.location.href = `/RequestAssetHire`;
            // window.location.href =
            //   state.quotationTypeId === 1
            //     ? `/RequestAssetPurchase`
            //     : `/RequestAssetHire`;
          });
        }
      }
      // else {
      //   Swal.fire("Success!", `${response?.message}`, "success").then(() => {
      //     window.location.href = `/RequestAssetHire`;
      //     // window.location.href =
      //     //   state.quotationTypeId === 1
      //     //     ? `/RequestAssetPurchase`
      //     //     : `/RequestAssetHire`;
      //   });
      // }

      if (user?.isIframe) {
        window.parent.postMessage(
          { type: "CLOSE_IFRAME" },
          process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
        );
        return;
      } else {
        if (location.state.sourceUrl === "MyTasks") {
          navigate("/MyTasks");
        } else {
          navigate("/RequestAssetHire");
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isAssetPurchaseApprove: false }));
      console.log(error);
    }
  };

  const handleOnBackToDraftAssetRequest = async (e) => {
    e.preventDefault();
    try {
      let confirmationQuestion = `Are you sure you want to move this asset hire request back to draft?`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );
      if (!isConfirmed) return;
      setState((prev) => ({ ...prev, isAssetPurchaseBacktoDraft: true }));

      const response =
        await assetService.sendAssetQuotationPurchaseRequestBackToDraft(
          state.assetQuotationId,
          user?.userId,
          AssetSubStatus.RequestForAssetServiceOrderBacktoDraft,
          state.remark
          // state.quotationTypeId === 1
          //   ? AssetSubStatus.RequestForAssetPurchaseBacktoDraft
          //   : AssetSubStatus.RequestForAssetServiceOrderBacktoDraft
        );

      if (response?.isSuccess && response.statusCode === 200) {        
        await showSuccessMessage(response?.message);
        setState((prev) => ({
          ...prev,
          isAssetPurchaseBacktoDraft: false,
          isAddRemarkModalOpen: false,
        }));
        
        if (location.state.sourceUrl === "MyTasks") {
          navigate("/MyTasks");
        } else {
          navigate("/RequestAssetHire");
        }
      }
      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setState((prev) => ({ ...prev, isAssetPurchaseBacktoDraft: false }));
        return;
      }
      // Swal.fire("Success!", `${response?.message}`, "success").then(() => {
      //   window.location.href = `/RequestAssetHire`;
      //   // window.location.href =
      //   //   state.quotationTypeId === 1
      //   //     ? `/RequestAssetPurchase`
      //   //     : `/RequestAssetHire`;
      // });
      if (response?.isSuccess) {
        if (user?.isIframe) {
          window.parent.postMessage(
            { type: "CLOSE_IFRAME" },
            process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
          );
          return;
        } else {
          if (location.state.sourceUrl === "MyTasks") {
            navigate("/MyTasks");
          } else {
            navigate("/RequestAssetHire");
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isAssetPurchaseBacktoDraft: false }));
      console.log(error);
    }
  };

  const handleOnBackToDraftAssetReCall = async (e) => {
    e.preventDefault();
    try {
      if (isValidRemarkData()) {
        let confirmationQuestion = `Are you sure want to recall ${
          state.quotationTypeId === 1 ? `asset purchase` : `asset hire`
        }?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isAssetPurchaseRecall: true }));
        const response =
          await assetService.sendAssetQuotationPurchaseRequestBackToReCall(
            state.assetQuotationId,
            user?.userId,
            state.remark
          );
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isAssetPurchaseRecall: false }));
        if (response?.isSuccess) {
          if (user?.isIframe) {
            window.parent.postMessage(
              { type: "CLOSE_IFRAME" },
              process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
            );
            return;
          } else {
            if (location.state.sourceUrl === "MyTasks") {
              navigate("/MyTasks");
            } else {
              navigate("/RequestAssetHire");
            }
          }
        }
        //return;
      }
      // Swal.fire("Success!", `${response?.message}`, "success").then(() => {
      //   window.location.href = `/RequestAssetHire`;
      //   // window.location.href =
      //   //   state.quotationTypeId === 1
      //   //     ? `/RequestAssetPurchase`
      //   //     : `/RequestAssetHire`;
      // });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnOpenAddRemarkModal = (actionTypeId) => {
    try {
      setState((prev) => ({
        ...prev,
        isAddRemarkModalOpen: true,
        actionTypeId: actionTypeId,
      }));
      let err = { ...errors };
      err.remarkValidation = "";
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseAddRemarkModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isAddRemarkModalOpen: false,
        remark: "",
        isAssetPurchaseBacktoDraft: false,
        isAssetPurchaseApprove: false,
        isAssetPurchaseRecall: false,
        actionTypeId: 0,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card top-bottom">
          {/* style={{ display: isPreviewOnly ? "none" : "" }} */}
          <div className="card-body">
            {!user?.isIframe && (
              <>
                <Button
                  text="Back"
                  icon="back"
                  onClick={() => {
                    if (sourceUrl === "RequestAssetHire") {
                      navigate("/RequestAssetHire");
                    } else if (sourceUrl === "ReportAssetHire") {
                      navigate("/ReportAssetHire");
                    } else if (sourceUrl === "PendingAssetRequest") {
                      navigate("/PendingAssetRequest");
                    } else if (sourceUrl === "UploadSAPRequestAssetHire") {
                      navigate("/PendingPRSAP");
                    } else if (sourceUrl === "ImportSAPRequestAssetHire") {
                      navigate("/ImportPR");
                    } else if (sourceUrl === "AcknowledgeRequestAssetHire") {
                      navigate("/assetAcknowledge");
                    } else if (sourceUrl === "MyTasks") {
                      navigate("/MyTasks");
                    }

                    // if (!location?.state?.isReport) {
                    //   navigate(
                    //     sourceUrl !== null && sourceUrl !== undefined
                    //       ? "/" + sourceUrl
                    //       : `${
                    //           location?.state.quotationTypeId === 1
                    //             ? "/RequestAssetPurchase"
                    //             : "/RequestAssetHire"
                    //         }`
                    //   );
                    // } else {
                    //   navigate(
                    //     sourceUrl !== null && sourceUrl !== undefined
                    //       ? "/" + sourceUrl
                    //       : `${
                    //           location?.state.quotationTypeId === 1
                    //             ? "/ReportAssetPurchase"
                    //             : "/ReportAssetHire"
                    //         }`
                    //   );
                    // }
                  }}
                  stylingMode="outlined"
                  type="default"
                  className="mr-2"
                  hint="Back"
                />
              </>
            )}

            {!location?.state?.isReport && (
              <>
                {assetData?.isApproved === true && (
                  <>
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      hidden={!props?.featurePermission?.canApprove}
                      onClick={() => {
                        handleOnOpenAddRemarkModal(1);
                      }}
                    >
                      <span title="Approve">
                        <i className="fas fa-check" />
                        &nbsp;&nbsp;Approve
                      </span>
                    </button>
                    &nbsp;&nbsp;
                  </>
                )}
                {assetData?.isSendBackToDraft === true && (
                  <>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => {
                        handleOnOpenAddRemarkModal(2);
                      }}
                    >
                      <span title="Back to Draft">
                        <i className="fas fa-arrow-left" />
                        &nbsp;&nbsp;Back to Draft
                      </span>
                    </button>
                    &nbsp;&nbsp;
                  </>
                )}
                {assetData?.isRollBack === true && (
                  <>
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => {
                        handleOnOpenAddRemarkModal(3);
                      }}
                    >
                      <span title="Recall">
                        <i className="fas fa-undo" />
                        &nbsp;&nbsp;Recall
                      </span>
                    </button>
                    &nbsp;&nbsp;
                  </>
                )}
              </>
            )}
            <button
              type="button"
              className="btn btn-primary btn-sm"
              hidden={!props?.featurePermission?.canPrint}
              onClick={async (e) => {
                window.print();
              }}
            >
              <span title="Print">
                <i className="fas fa-print" />
                &nbsp;&nbsp;Print
              </span>
            </button>
          </div>
        </div>
        <div className="row">
          {/* {isPreviewOnly && <div className='col-lg-2 col-md-3'></div>} */}
          {/* <div ref={contentRef}> */}
          <div className={"col-lg-9 col-md-6"}>
            <div className="card">
              <div className="card-body">
                <table width="100%" className="page-header">
                  <tr>
                    <td>
                      <div className="imglogo mt-2">
                        <img
                          src="https://vishwasamudra.in/wp-content/uploads/2022/11/New-Project.png"
                          alt="DigilinkZ | Streamlining Storage, Access & Organization"
                          width="150"
                          className=""
                        />
                      </div>
                    </td>
                    <td align="right">
                      <h6
                        className="mb-1"
                        style={{ fontSize: "0.8rem", color: "#282C7D" }}
                      >
                        Registered Office
                      </h6>
                      <p className="mb-0 pb-0 small">
                        8th & 9th Floors, Vamsiram Jyothi Valencia,<br></br>
                        Road No. 2, Banjara Hills, Hyderabad – 500034
                      </p>
                    </td>
                  </tr>
                </table>
                <div
                  className="text-center mt-5 mb-4 imo-page-title"
                  style={{
                    backgroundColor: "#ebebeb",
                    paddingTop: "7px",
                    paddingBottom: "7px",
                    border: "1px solid #ebebeb",
                  }}
                >
                  <table width="100%">
                    <tr>
                      <td className="text-center">
                        <h4
                          className="mb-0"
                          style={{ fontWeight: "700", color: "#282c7d" }}
                        >
                          {/* {state.quotationTypeId === 1
                            ? "ASSET PURCHASE INDENT NO"
                            : "ASSET HIRE INDENT NO"} */}
                          {"ASSET HIRE INDENT NO"}
                        </h4>
                        <h6 className="mb-0 mr-3" style={{ fontWeight: "600" }}>
                          {assetData?.quotationIndentNo}
                        </h6>
                      </td>
                      {/* <td width="50%" className='text-right'></td> */}
                    </tr>
                  </table>
                </div>
                <div className="imo-basic-detail">
                  <table cellPadding="2">
                    <tr>
                      <td width="180px" style={{ fontSize: "0.9rem" }}>
                        From
                      </td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.fromName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>To</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.toName}
                      </td>
                    </tr>
                    {/* <tr>
                                            <td style={{ fontSize: "0.9rem" }}>From Project</td>
                                            <td
                                                style={{
                                                    fontSize: "0.9rem",
                                                    fontWeight: "500",
                                                    color: "#282C7D",
                                                }}
                                            >
                                                {assetData?.fromProjectName}
                                            </td>
                                        </tr> */}
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Project</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.toProjectName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Asset Request No.</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.assetRequestNo}
                      </td>
                    </tr>
                    {/* <tr>
                                            <td style={{ fontSize: "0.9rem" }}>FR No.</td>
                                            <td
                                                style={{
                                                    fontSize: "0.9rem",
                                                    fontWeight: "500",
                                                    color: "#282C7D",
                                                }}
                                            >
                                                {assetData?.movementIndentNo}
                                            </td>
                                        </tr> */}
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>
                        Purchase request date
                      </td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.requestedDate
                          ? new Date(
                              assetData?.requestedDate
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Note</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.note}
                      </td>
                    </tr>
                  </table>
                </div>
                <div>
                  <hr></hr>
                </div>
                <div>
                  <u>Vendor Details</u>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-12">
                    <div className="form-group mb-2">
                      <DataGrid
                        id="quotationAllVendorLineItemLst"
                        dataSource={quotationAllVendorLineItemLst}
                        showBorders={true}
                        columnAutoWidth={true}
                        allowColumnResizing={true}
                        showRowLines={true}
                        showColumnLines={true}
                        sorting={false}
                      ></DataGrid>
                    </div>
                  </div>
                </div>
                <div className="message-body displayNone">
                  <table width={"100%"} className="asset-details">
                    <thead>
                      <tr>
                        <th>Vendor Name</th>
                        <th>Model</th>
                        <th>Quotation Level</th>
                        <th>Price</th>
                        <th>Gst(%)</th>
                        <th>Total Amount</th>
                        {/* <th>Quotation Date</th> */}
                        {/* <th>Transport Charges</th>
                                                <th>Remarks</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {assetQuotationVendorLst?.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.vendorName}</td>
                          <td>{item?.modelNo}</td>
                          <td>{item?.quotationLevel}</td>
                          <td>{parseFloat(item?.quotationAmount, 2)}</td>
                          <td>{parseFloat(item?.gst, 2)}</td>
                          <td>{parseFloat(item?.totalAmount, 2)}</td>
                          {/* <td>{item?.quotationDate}</td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="displayNone">
                  <u>
                    {/* {state.quotationTypeId === 1
                      ? "Purchase Note"
                      : "Hire Note"} */}
                    {"Hire Note"}
                  </u>
                </div>
                <br />
                <div
                  className="message-body displayNone"
                  dangerouslySetInnerHTML={{ __html: purchaseContent }}
                ></div>
                {/* <div className="imo-basic-detail">
                                    <table cellPadding="2">
                                        <tr>
                                            <td width="150px" style={{ fontSize: "0.9rem" }}>
                                                Note
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: "0.9rem",
                                                    fontWeight: "500",
                                                    color: "#282C7D",
                                                }}
                                            >
                                                {assetData?.note}
                                            </td>
                                        </tr>
                                    </table>
                                </div> */}
                <div className="page-footer">www.vishwasamudra.in</div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 reviews">
            <div className="card">
              <div className="card-body">
                <div className="mb-1 sub-title-color">REMARKS</div>
                <div className="list-group">
                  {assetData?.history?.map((item, index) => (
                    <div
                      key={index}
                      className="list-group-item list-group-item-action flex-column align-items-start"
                      style={{
                        borderBottom: "1px solid #cfcfcf",
                        marginBottom: "0.5rem",
                        paddingBottom: "0.5rem",
                      }}
                    >
                      <div
                        className="small mb-1"
                        style={{ color: "#282c7d", fontWeight: "500" }}
                      >
                        {item.statusName} by {item.fullName}
                      </div>
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <small>{item?.updatedOn}</small>
                      </div>
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <small>Message</small>
                        <small>
                          {item.remarkDate ?? ""}
                          {/* {item.remarkDate
                            ? new Date(item.remarkDate).toLocaleDateString('en-GB', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric'
                            }) +
                            ' ' +
                            new Date(item.remarkDate).toLocaleTimeString('en-GB', {
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true
                            })
                            : ''} */}
                        </small>
                      </div>
                      <div
                        className="small"
                        style={{ fontSize: "0.8rem", fontStyle: "italic" }}
                      >
                        {item.remarks}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {assetQuotationVendorAttachment?.length === 0 ? (
              ""
            ) : (
              <div className="card">
                <div className="card-body">
                  <div className="mb-1 sub-title-color">ATTACHMENTS</div>
                  {assetQuotationVendorAttachment?.map((item, index) => (
                    <div className="list-group">
                      <div
                        key={index}
                        className="list-group-item list-group-item-action flex-column align-items-start"
                        style={{
                          borderBottom: "1px solid #cfcfcf",
                          marginBottom: "0.5rem",
                          paddingBottom: "0.5rem",
                        }}
                      >
                        <div className="d-flex w-100 justify-content-between align-items-center">
                          <small
                            style={{ cursor: "pointer", color: "blue" }}
                            onClick={() => {
                              window.open(item?.fileUrl, "_blank");
                            }}
                          >
                            {item?.assetFileName}
                            <br />
                            <span style={{ color: "black", fontSize: "12px" }}>
                              [{item?.vendorName}]
                            </span>
                          </small>
                          <small>{item?.fileSize} kb</small>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="web-page-footer">www.vishwasamudra.in</div>
      </div>

      {/* For Adding Remark (Approve/Back To Draft/Recall) */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isAddRemarkModalOpen}
        className={"react-modal custom-modal-small"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Adding Remark (Approve/Back To Draft/Recall)"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {state.actionTypeId === 1
              ? "Send for Approval"
              : state.actionTypeId === 2
              ? "Back To Draft"
              : state.actionTypeId === 3
              ? "Recall"
              : ""}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseAddRemarkModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <label>
                  Remark&nbsp;<span className="text-danger">*</span>
                </label>
                <TextArea
                  className="form-control"
                  placeholder="Enter remark"
                  showClearButton={true}
                  height={150}
                  valueChangeEvent="keyup"
                  value={state.remark}
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.remarkValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      remark: e.value,
                    }));
                  }}
                />
                {errors.remarkValidation && (
                  <div className="text-danger">{errors.remarkValidation}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            title="Submit"
            onClick={async (e) => {
              if (state.actionTypeId === 1) {
                await handleOnUpdateAssetRequest(e);
              } else if (state.actionTypeId === 2) {
                await handleOnBackToDraftAssetRequest(e);
              } else if (state.actionTypeId === 3) {
                await handleOnBackToDraftAssetReCall(e);
              }
            }}
            disabled={
              state.actionTypeId === 1
                ? state.isAssetPurchaseApprove
                : state.actionTypeId === 2
                ? state.isAssetPurchaseBacktoDraft
                : state.actionTypeId === 3
                ? state.isAssetPurchaseRecall
                : false
            }
          >
            <span title="Submit">
              {state.actionTypeId === 1 ? (
                <>
                  <i
                    className={`fas fa-${
                      state.isAssetPurchaseApprove ? `spinner fa-spin` : `check`
                    }`}
                  />
                </>
              ) : state.actionTypeId === 2 ? (
                <>
                  <i
                    className={`fas fa-${
                      state.isAssetPurchaseBacktoDraft
                        ? `spinner fa-spin`
                        : `check`
                    }`}
                  />
                </>
              ) : state.actionTypeId === 3 ? (
                <>
                  <i
                    className={`fas fa-${
                      state.isAssetPurchaseRecall ? `spinner fa-spin` : `check`
                    }`}
                  />
                </>
              ) : null}
              &nbsp;&nbsp;Submit
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseAddRemarkModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
